import { createContext, useContext, useEffect, useState } from 'react';
import { api, tokenStore } from 'lib/api';

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!tokenStore.get()) { setLoading(false); return; }
    api.get('/auth/me')
      .then((a) => { if (a.role === 'admin' || a.tier === 'pro') setAccount(a); else tokenStore.set(null); })
      .catch(() => tokenStore.set(null))
      .finally(() => setLoading(false));
  }, []);

  const loginParent = async (email, password) => {
    const r = await api.post('/auth/login', { email, password });
    if (r.account.role !== 'admin' && r.account.tier !== 'pro')
      throw new Error('Portal chỉ dành cho gói Pro. Hãy dùng app và nâng cấp trước.');
    tokenStore.set(r.token); setAccount(r.account);
  };
  const loginAdmin = async (username, password) => {
    const r = await api.post('/auth/admin', { username, password });
    tokenStore.set(r.token); setAccount(r.account);
  };
  // Đăng nhập bằng Google (GIS trả id_token). Backend yêu cầu tài khoản đã tạo từ app trước.
  const loginGoogle = async (idToken) => {
    const r = await api.post('/auth/portal/google', { idToken });
    if (r.account.role !== 'admin' && r.account.tier !== 'pro')
      throw new Error('Portal chỉ dành cho gói Pro. Hãy dùng app và nâng cấp trước.');
    tokenStore.set(r.token); setAccount(r.account);
  };
  // Đăng nhập nhanh từ app: đổi mã handoff (mở từ app) lấy phiên portal.
  const loginHandoff = async (code) => {
    const r = await api.post('/auth/portal-exchange', { code });
    if (r.account.role !== 'admin' && r.account.tier !== 'pro')
      throw new Error('Portal chỉ dành cho gói Pro. Hãy dùng app và nâng cấp trước.');
    tokenStore.set(r.token); setAccount(r.account);
  };
  const logout = () => { tokenStore.set(null); setAccount(null); };
  const refresh = async () => {
    try { const a = await api.get('/auth/me'); setAccount(a); return a; } catch { return null; }
  };

  return <Ctx.Provider value={{ account, loading, loginParent, loginAdmin, loginGoogle, loginHandoff, logout, refresh }}>{children}</Ctx.Provider>;
}
export const useAuth = () => useContext(Ctx);
